import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Modes, DataDtmActions} from '../common/Constants';
import Tags from '../common/dtmTags';
import AlgoliaWrapper from '../directory/algolia/AlgoliaWrapper';
import ErrorContainer from '../common/components/ErrorContainer';
import TranslationService from '../translations';
import ProductRestriction from '../common/buyers/productRestriction';
import EventEditionService from '../common/api/EventEditionService';
import BigCircleSpinner from '../common/components/BigCircleSpinner';
import {trackMixpanelEvent} from '../common/MixpanelHelper';
import mixpanelConstants from '../common/mixpanelConstants';

const ProductDirectoryWithFilters = (props) => {
    const {
        algoliaConfig = {}, context, assets, navigation, testVariants, baseApiUrl
    } = props;
  const translation = TranslationService.getTranslations(context.interfaceLocale);
    const [isProductEnabled, setIsProductEnabled] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [featureFilterName, setFeatureFilterName] = useState('');
    const getIndexName = () => {
      return `${props.context.eventId}-index`
    };
    const indexName = getIndexName();
    const pageTitle = decodeURIComponent(window?.reactSettingsProductsDirectory?.props?.context?.title) || '';
  useEffect(  () => {
      EventEditionService.getEventEdition(baseApiUrl, context.interfaceLocale, context.eventEditionId).then(async(eventEditionResponse) => {
          const restrictProductDirectory =eventEditionResponse.isParticipationEvent && window?.featureFilters?.restrictProductDirectory;
          const featureFilter =  await ProductRestriction.getUnrestrictedFeatureFilter(baseApiUrl,context.eventEditionId,context.interfaceLocale);
             if (featureFilter) {
                 setFeatureFilterName(featureFilter.multilingualNames[0].name);
             }

            if (restrictProductDirectory) {
                await ProductRestriction.checkIsValidBuyer(baseApiUrl, context.eventEditionId, context.interfaceLocale).then(isValidBuyer => {
                    setIsProductEnabled(isValidBuyer);
                    setIsLoading(false);
                });
            } else {
                setIsProductEnabled(!restrictProductDirectory);
                setIsLoading(false);
            }
        });
      trackMixpanelEvent(mixpanelConstants.eventName.productDirectoryVisited, {
        component: mixpanelConstants.component.productDirectory
      })
    },[]);

    return (
        <div data-dtm={Tags.productDirectory.component} data-dtm-actions={DataDtmActions.view}>

            { isLoading ? <BigCircleSpinner/> :
            isProductEnabled?
                <AlgoliaWrapper
                  eventEditionId={context.eventEditionId}
                  locale={context.interfaceLocale}
                  appId={algoliaConfig.appId}
                  indexName={indexName}
                  apiKey={algoliaConfig.apiKey}
                  navigation={navigation}
                  context={context}
                  assets={assets}
                  testVariants={testVariants}
                  showPlan={{}}
                  baseApiUrl={baseApiUrl}
                  pageTitle={pageTitle}
                  directoryPage={'product'}
              />
             :
             <ErrorContainer errors={[featureFilterName +' ' + translation.productDirectory.usersOnlyDetails ]}/>
            }
        </div>
    );
};

ProductDirectoryWithFilters.propTypes = {
  assets: PropTypes.shape({
    defaultOrganisationListingLogoUrl: PropTypes.string.isRequired
  }).isRequired,
  navigation: PropTypes.shape({
    exhibitorPublicDetailsUrlFormat: PropTypes.string.isRequired
  }).isRequired,
  context: PropTypes.shape({
    eventEditionId: PropTypes.string.isRequired,
    eventId: PropTypes.string.isRequired,
    interfaceLocale: PropTypes.string.isRequired,
    primaryLocale: PropTypes.string.isRequired,
    mode: PropTypes.oneOf([Modes.private, Modes.protected, Modes.public]),
    tenants: PropTypes.string
  }).isRequired,
  algoliaConfig: PropTypes.shape({
    appId: PropTypes.string.isRequired,
    apiKey: PropTypes.string.isRequired
  }).isRequired,
  testVariants: PropTypes.arrayOf(PropTypes.string),
  baseApiUrl: PropTypes.string.isRequired
};

export default ProductDirectoryWithFilters;
